/**
 * Lets non-React code (axios interceptor, apiFetch) trigger SPA navigation.
 * Registered from a component under BrowserRouter when the user is authenticated.
 */

type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

let navigateRef: NavigateFn | null = null;

export function registerAppNavigator(fn: NavigateFn | null): void {
  navigateRef = fn;
}

export function appNavigate(to: string, options?: { replace?: boolean }): void {
  if (navigateRef) {
    navigateRef(to, options);
  } else {
    const path = to.startsWith('/') ? to : `/${to}`;
    window.location.replace(`${window.location.origin}${path}`);
  }
}
